export default {
    locale: "de",    
    more: 'Mehr',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    save: 'Speichern',
    remove: 'Löschen',
    open: 'Öffnen',
    showing: 'Zeige',
    of: 'von',
    from: 'Von',
    to: 'Bis',
    toSmall: 'bis',
    entries: 'Einträgen',
    entry: 'Eintrag',
    logout: 'Abmelden',
    yes: 'Ja',
    ok: 'Übernehmen',
    no: 'Nein',
    username: 'Benutzer',
    password: 'Passwort',
    login: 'Anmelden',
    show: 'Anzeigen',
    zoom: 'Vergrössern',
    searchPlaceholder: 'Suchen...',
    loadingPlaceholder: 'Laden...',
    noItems: 'Es wurden leider keine Einträge zu Ihrer Suchanfrage gefunden.',
    search: 'Suche',
    none: 'Keine ',
    help: 'Hilfe',
    continue: 'Weiter',
    close: 'Schliessen',
    download_file: '${title} herunterladen',
    unknownError: 'Ein unbekannter Fehler ist aufgetreten. Versuchen Sie neuzuladen, wenn dies nicht funktioniert laden Sie die ganze Seite neu.',
    passwordPlaceholder: '******',
    columns: "Spalten",
    filter: "Filter",
    reset_columns: "Spalten zurücksetzen",
    reset_filters: "Filter zurücksetzen",
    modelTitle: '${title}',
    modelTitleWithContinue: 'Schritt 1: ${title}',
    addNewModel: '${fieldName}',
    addNewModelWithQuery: '${query}',
    selectMultipleOptions: 'Select ${title}',
    calendar: "Kalender",
    calendarLocale: {
        resultsExceedsMaxPages: "Please refine your search to see accurate results",
        buttonText: {
            prev: 'Zurück',
            next: 'Vor',
            today: 'Heute',
            year: 'Jahr',
            month: 'Monat',
            week: 'Woche',
            day: 'Tag',
            list: 'Terminübersicht',
        },
        weekText: 'KW',
        allDayText: "All Day",
        noEventsText: 'Keine Ereignisse anzuzeigen',
        moreLinkText: "+ ${count} more"
    },

    loginPage: {
        welcomeTitle: 'Willkommen zu Veranstaltungsbutler',
        welcomeMessage: 'Bitte melden Sie sich oben rechts mit Ihrem Benutzernamen und Passwort an.',
        loginErrorTitle: 'Login fehlgeschlagen',
        noCredentials: 'Bitte geben Sie Ihre Anmeldedaten ein.',
        forgotPassword: "Forgot Password?",
    },
    forgotPasswordPage: {
        welcomeTitle: 'Willkommen bei Websail',
        welcomeMessage: 'Bitte geben Sie Ihren Benutzernamen ein',
        errorTitle: 'Fehler',
        noCredentials: 'Bitte geben Sie Ihren Benutzernamen oder Ihre E-Mail-Adresse ein.',
        successTitle: 'Link Sent', 
        successMessage: 'Ein Link zum Zurücksetzen Ihres Passworts wurde an Ihre E-Mail-Adresse gesendet.', 
        submitButton: "Passwort zurücksetzen",
        login: "Log in",
    },
    resetPasswordPage: {
        welcomeTitle: 'Willkommen bei Websail',
        errorTitle: 'Fehler',
        welcomeMessage: 'Bitte geben Sie Ihr neues Passwort ein',
        noCredentials: 'Passwort und Passwortbestätigung sind erforderlich.',
        confirmPassword: "Passwort bestätigen",
        submitButton: "Passwort zurücksetzen",
        login: "Log in",
    },

    errorPage: {
        title: 'Da ist leider etwas schiefgelaufen...',
        sorry: 'Wir bedauern alle aufgetretenen Unannehmlichkeiten. Wenn Sie Fragen haben, können Sie uns gerne unter unserer Durchwahl ${supportNumber} erreichen.',
        hintTitle: 'Wie Sie den aufgetretenen Fehler möglicherweise beheben können',
        hint1: 'Gehen Sie eine Seite zurück',
        hint2: 'Laden Sie die Seite neu',
        hint3: 'Starten Sie Ihren Browser neu',
        hint4: 'Benutzen Sie Google Chrome',
    },
    
    notFoundPage: {
        title: 'Die angeforderte Seite wurde nicht gefunden',
        message: 'Die von Ihnen angeforderte Seite konnte leider nicht gefunden werden. Haben Sie sich möglicherweise vertippt?'
    },

    notAuthorizedPage: {
        title: 'Sie haben keinen Zugriff auf diese Seite',
        message: 'Wenden Sie sich für weitere Informationen an den Systemadministrator.'
    },

    errors: {
        options: 'Das laden der Optionen ist fehlgeschlagen. Bitte laden Sie die Seite neu und versuchen Sie es erneut.'
    },



    confirmNavigation: {
        title: 'Warnung',
        message: 'Sind Sie sicher, dass Sie Ihre Änderungen verwerfen wollen?',
        yes: 'Änderungen Verwerfen',
        no: 'Zurück'
    },

    confirmDelete: {
        title: 'Löschen bestätigen',
        message: 'Möchten Sie ${itemTitle} wirklich löschen?',
    },

    confirmAction: {
        title: '${actionTitle}',
        message: 'Möchten Sie ${itemTitle} wirklich ${actionTitle}?',
        criticalConfirm: "Bitte geben Sie \"${confirmText}\" ein, um fortzufahren.",
    },

    requiresSelection: {
        title: "Mit allen ${count} ${modelNamePlural} fortfahren",
        message: "Möchten Sie alle ${count} ${modelNamePlural} fortfahren? Sie können auf der linken Seite auch einzelne Einträge auswählen.",
    },

    time: {
        dateTimeFormat: 'ddd d.m H:MM',
        dateFormat: 'ddd d.m',
        timeFormat: 'H:MM',

        weekdaysShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        weekdaysLetter: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        monthsShort: ['Jan','Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        weekdays: [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag'
        ],
    },

    page_navigation: {
        tooltip: 'Anzahl der Einträge pro Seite festlegen'
    },

    pagination: {
        tooltip: 'Wenn mehr Einträge gefunden wurden, als pro Seite angezeigt werden, kann hier die aktuelle Seite geändert werden.'
    },

    table: {
        select_throughout_pages: "Alle ${count} Einträge auf dieser Seite ausgewählt.",
        select_throughout_pages_button_label: "Alle Einträge auswählen",
        clear_select_throughout_pages: "Alle Einträge ausgewählt.",
        clear_select_throughout_pages_button_label: "Auswahl aufheben",
        selectAll: "Select all",
        unselectAll: "Unselect all",
        selectRow: "Select row",
        unselectRow: "Unselect row",
        title_and_count: "${count} ${title}",
    },

    versions: {
        booking_form: "Buchungsformular",
        admin: "Veranstaltungsbutler",
        backend: "API"
    },

    booking_form: {
        create_booking: "+ Buchung",
        something_went_wrong: "Ein unbekannter Fehler ist aufgetreten. Versuchen Sie die Seite neu zu laden oder wenden Sie sich an die Kundenbetreuung",
    },

    mobile_login: {
        title: "Scanner app authentifizieren",
        description: "",
        image_loading_help_text: "Bitte warten, der QR Code wird geladen.",
    },

    menu: {
        customers: 'Kunden',
        customer: 'Kunde',
        bookings: 'Buchungen',
        booking: 'Buchung',
        courses: 'Veranstaltungen',
        scheduling: 'Terminvereinbarung',
        exams: 'Prüfungen',
        bills: 'Rechnungen',
        bill: 'Rechnung',
        payments: 'Zahlungen',
        payment: 'Zahlung',
        articleTypes: 'Artikelkategorien',
        articles: 'Artikel',
        courseCategories: 'Veranstaltungskategorien',
        examCategories: 'Prüfungskategorien',
        employees: 'Mitarbeiter',
        notifications: 'E-Mail CC\'s',
        taxes: 'Steuersätze',
        salutations: 'Anreden',
        options: 'Einstellungen',
        partialExams: 'Prüfungsthemen',
        places: 'Adressen',
        prices: 'Enthaltene Preise',
        documents: 'Dokumentenarchiv',
        templates: 'Dokumentenvorlagen',
        content_blocks: 'Textbausteine',
        help: 'Hilfe',
        message_templates: 'Nachrichtenvorlagen',
        consents: 'Einverständniserklärung',
        consent_user: 'Gegebene Einverständniserklärung',
        tags: 'Tags',
        tag_types: 'Tagging-Einstellungen',
        banks: 'Bankkonten',
        bank_transactions: 'Kontoumsätze',
        sepa_direct_debit_mandates: 'Lastschriftmandate',
        exam_booking: 'Prüflinge',
        exam_booking_single: 'Prüfling',
        files: 'Dateianhänge',
        openHelp: 'Hilfe',
        hideTooltips: 'Tooltips ausblenden',
        showTooltips: 'Tooltips anzeigen',
        outgoingMessages: 'Nachrichten',
        payment_gateway_configs: 'Zahlungsarten',
        aboutUs: "Version",
        downloadOniOS: "iOS Ticket Scanner",
        downloadOnAndroid: "Android Ticket Scanner",
        loginOnMobile: "Scanner app authentifizieren"
    },

    menuTooltips: {
        customerGroup: 'alles zu Kunden und Kommunikation',
        customers: ' Kunden anlegen, verwalten miteinbezogen aller Stammdaten, Rechnungen, Buchungen, u.v.m.',
        outgoingMessages: 'alle versendeten Nachrichten (SMS und E-Mail) im Überblick',
        courseGroup: 'alles zu Veranstaltungen und was dazugehört (Veranstaltungen, Buchungen, Prüfungen, u.v.m.)',
        billing: 'alles zu Buchhaltung und was dazugehört (Rechnungen, Zahlungen, u.v.m.)',
        search: 'durchsuche deine gesammte Datenbank (Kunden, Nachrichten, Buchungen, u.v.m.) nach einem Suchbegriff',
        addFast: 'füge einen neuen Eintrag hinzufügen',
        settings: 'Konfiguration',
        help: 'öffne die Hilfe oder blende die Schnellhilfe ein/aus',
        ownAccount: 'dein Nutzerkonto',
        course_timespans: 'Veranstaltungen anlegen, verwalten, deren Teilnehmer einsehen und Teilnehmerlisten ausdrucken',
        bookings: 'Buchungen erstellen, bestehende verwalten, stornieren und Buchungsbestätigungen versenden',
        exams: 'Prüfungen anlegen, verwalten, deren Teilnehmer einsehen und Teilnehmerlisten ausdrucken',
        exam_booking: 'Prüflinge anmelden und bestehende verwalten',
        bills: 'Rechnungen erstellen, verwalten, versenden und ausdrucken',
        payments: 'Zahlungen anlegen und verwalten',
        bank_transactions: 'Kontoumsätze einsehen und bestehenden Rechnungen zuordnen',
        articles: 'Artikel anlegen und verwalten',
        new_customer: 'neuen Kunden anlegen',
        new_booking: 'neue Buchung erstellen',
        new_bill: 'neue Rechnung anlegen',
        new_payment: 'neue Zahlung anlegen',
        new_exam_booking: 'Person für Prüfung anmelden',
        courses: 'Veranstaltungskategorien erstellen und verwalten. Veranstaltungen können einer oder mehreren Kategorien zugeordnet sein, z.B. SBF-Binnen und Abendkurs oder SKS und Wochenendkurs',
        exam_types: 'Prüfungskategorien erstellen und verwalten. Mit Prüfungskategorien lassen sich Prüfungen einordnen, z.B. in die Kategorien SBF-Binnen- oder SKS Prüfungen',
        partial_exams: 'Prüfungsthemen erstellen und verwalten. Bei einer Prüfung können mehrere Themen geprüft werden, z.B. Theorie und/oder Praxis',
        article_types: 'Artikelkategorien erstellen und verwalten. Mit Artikelkategorien lassen sich Artikel kategoriesieren, z.B. in Lehrbücher und Segelbekleidung.',
        employees: 'Mitarbeiter anlegen und verwalten. Mitarbeiter bekommen ihren eigenen Login in Websail. So kann protokolliert werden, wer welchen Eintrag erstellt hat.',
        places: 'Adressen anlegen und verwalten. Die Adressen finden z.B in Veranstaltungen verwendung um den Standort festzulegen.',
        message_templates: 'Nachrichtenvorlagen anlegen und verwalten. Auf Basis der Nachrichtenvorlagen werden manuell, bei Buchung, Rechnungsstellung oder Zahlung Nachrichten per SMS oder E-Mail verschickt.',
        files: 'Dateianhänge für das versenden von Nachrichten hochladen und verwalten',
        consents: 'Einverständnisserklärungen anlegen und verwalten. Angelegte Einverständnisserklärungen müssen vom Kunden bestätigt werden - z.B Datenschutzbedingungen, AGB oder Newsletter um so dem DSGVO zu entsprechen.',
        consent_user: 'Vom Kunden gegebene Einverständnisserklärungen einsehen oder Einverständnisserklarungen mit Nachweis hochladen. Einverständnisserklarungen des Kundens werden mit Zeitstempel und IP-Adresse gespeichert um der Nachweispflicht zu entsprechen.',
        tags: 'Tags anlegen oder verwalten. Mit Tags ordnest du Einträge für eine bessere Übersicht.',
        banks: 'Bankkonten anlegen, verwalten und Kontoumsatz-Synchronisierung aktivieren.',
        hideTooltips: 'Schnellhilfe (?-Icons) im Menü, bei Tabellenspalten, Eingabefeldern, Filtern, u.v.m. ausblenden',
        showTooltips: 'Schnellhilfe (?-Icons) im Menü, bei Tabellenspalten, Eingabefeldern, Filtern, u.v.m. einblenden',
        payment_gateway_configs: '',

        harbour: 'Dies ist ein Platzhhalter. Platzhhalter fand ich schon immer eine gute Sache. Sie machen die Seite so ästhetisch. (Hafen)',
    },

    columns_configuration: {
        hideColumns: "Spalten ausblenden",
        hiddenColumnsCount: "${count} versteckte Spalten",
    },
    filters: {
        no_filters_applied: "Es werden keine Filterbedingungen angewendet.",
        add_filter: "Filter hinzufügen",
        select_filter: "Filter auswählen",
        filtered_by: "Gefiltert nach ${filters}",
        filtered_by_more_1: "Gefiltert nach ${0} und ${count} mehr",
        applied_filter_count: "${count} aktiv",
        where: "wo",
        and: "und",
        range: {
            number: {
                greater_than: "von ${value}",
                less_than: "bis ${value}",
                between: "zwischen ${min} - ${max}",
            },
            date: {
                greater_than: "nach ${value}",
                less_than: "vor ${value}",
                between: "zwischen ${min} - ${max}",
            },
            datetime: {
                greater_than: "nach ${value}",
                less_than: "vor ${value}",
                between: "zwischen ${min} - ${max}",
            },
            time: {
                greater_than: "nach ${value}",
                less_than: "vor ${value}",
                between: "zwischen ${min} - ${max}",
            },
        },
        text: {
            contains: "enthält",
        },
        number: {
            after: "Von",
            before: "Bis",
            between: "zwischen",
        },
        textarea: {
            contains: "enthält",
        },
        wysiwyg: {
            contains: "enthält",
        },
        bool: {
            includes: "umfasst",
        },
        yesno: {
            includes: "umfasst",
        },
        belongs_to: {
            includes: "umfasst",
        },
        belongs_to_many: {
            allOf: "alle",
        },
        date: {
            today: "Heute",
            tomorrow: "Morgen",
            yesterday: "Gestern",
            thisweek: "diese Woche",
            lastweek: "letzte Woche",
            nextweek: "nächste Woche",
            thismonth: "diese Monat",
            lastmonth: "letzter Monat",
            nextmonth: "nächster Monat",
            after: "nach",
            before: "vor",
            before_today: "vor heute",
            on_or_before_today: "am oder vor dem heutigen Tag",
            after_today: "nach heute",
            on_or_after_today: "am oder nach dem heutigen Tag",
            between: "zwischen",
        },
        datetime: {
            today: "Heute",
            tomorrow: "Morgen",
            yesterday: "Gestern",
            thisweek: "diese Woche",
            lastweek: "letzte Woche",
            nextweek: "nächste Woche",
            thismonth: "diese Monat",
            lastmonth: "letzter Monat",
            nextmonth: "nächster Monat",
            after: "nach",
            before: "vor",
            between: "zwischen",
        },
        time: {
            today: "Heute",
            tomorrow: "Morgen",
            yesterday: "Gestern",
            thisweek: "diese Woche",
            lastweek: "letzte Woche",
            nextweek: "nächste Woche",
            thismonth: "diese Monat",
            lastmonth: "letzter Monat",
            nextmonth: "nächster Monat",
            after: "nach",
            before: "vor",
            before_today: "vor heute",
            on_or_before_today: "am oder vor dem heutigen Tag",
            after_today: "nach heute",
            on_or_after_today: "am oder nach dem heutigen Tag",
            between: "zwischen",
        },
        file: {
            contains: "enthält",
        },
        image: {
            contains: "enthält",
        },
    },
    user: {
        profile: "Profile",
    },
    views: {
        renameView: "Umbenennen",
        saveViewName: "Speichern",
        shareView: "Teilnehmen",
        unshareView: "Abmelden",
        sharedView: "Geteilte Ansicht",
        deleteView: "Löschen",
        copyTitle: "${title} Kopieren",
        archivedViewTitle: "${title} (archiviert)",
        duplicateCurrentView: "Neue Ansicht",
        save: "Speichern",
        saveAsOwn: "Als eigene speichern",
        confirmResetLastView: "${title} ist die letzte verfügbare Ansicht. Diese Ansicht wird zurückgesetzt.",
    },
}